import { Button, Flex } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { useI18n } from "next-localization";
import colors from "themes/foundations/color";
import BundleIcon from "../BundleIcon";

interface CarouselNavButtonProps {
    navSpace?: number | string;
    navType: "next" | "prev";
    marginSpace?: number | string | (number | string | null)[];
    onClick: () => void;
}

const CarouselNavButton = (props: CarouselNavButtonProps) => {
    const { onClick, navType, navSpace, marginSpace } = props;
    const [isHoveredOn, setIsHoveredOn] = useState<boolean>(false);
    const contentRef = useRef<any>();

    const navSpaceValue = navSpace ?? 100;

    const handleMouseEnter = () => setIsHoveredOn(true);
    const handleMouseLeave = () => setIsHoveredOn(false);

    const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (isHoveredOn && contentRef.current) {
            contentRef.current.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
        }
    };
    const { t } = useI18n();

    return (
        <Button
            aria-label={navType === "next" ? t("carouselNextBtnLabel") : t("carouselPrevBtnLabel")}
            display={["none", null, null, "block"]}
            variant="unstyled"
            position="absolute"
            top="auto"
            height="100%"
            bottom={0}
            right={navType === "next" ? marginSpace : "auto"}
            left={navType === "next" ? "auto" : marginSpace}
            width={navSpaceValue}
            zIndex={2}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
            onClick={onClick}
            cursor="none"
        >
            <Flex
                as="span"
                ref={contentRef}
                position="fixed"
                overflow="hidden"
                top={0}
                left={0}
                width={isHoveredOn ? "carouselNavigationButtonSize" : 0}
                height={isHoveredOn ? "carouselNavigationButtonSize" : 0}
                padding={0}
                pointerEvents="none"
                borderRadius="100%"
                bg={colors.brand.orange}
                justifyContent="center"
                alignItems="center"
                zIndex={2}
                transition="width 0.15s ease, height 0.15s ease"
                transformOrigin="center"
            >
                <BundleIcon
                    name="ArrowForwardIos"
                    mr={navType === "prev" ? 2 : 0}
                    transform={navType === "prev" ? "scaleX(-1)" : "none"}
                />
            </Flex>
        </Button>
    );
};

export default CarouselNavButton;
